import { useQuery } from 'react-query';
import { api } from '../services/api';
// import { IConsultStatus } from './types/BatchConsults';

const basePath = 'debts';

export interface IMandatoryDebt {
  additionalDescription: string;
  consultNumber: string;
  debtsCode: number;
  description: string;
  price: number;
  type: string;
}

export interface IDebts {
  vehiclePlate: string;
  vehicleUF: string;
  totalMandatory: number;
  driverName?: string;
  expirationDate: string;
  isExpirationDate: string;
  onCheck: {
    unSelect: IMandatoryDebt[];
    select: IMandatoryDebt[];
  };
  consultName: string;
  dueDate: string;
  issuer: string;
  subUser: string;
  debtsCode: number;
  consultDate: string;
  batchId?: number;
  createdAt: string;
  isExpired: boolean;
  onUnCheck: {
    unSelect: IMandatoryDebt[];
    select: IMandatoryDebt[];
  };
  isDuplicated: boolean;
  disabled: string;
  correlationId: string;
  uniqueId: string;
  description: string;
  price: number;
  consultNumber: string;
  additionalDescription?: string;
  type: string;
}

export interface IGetDebtsResult {
  results: IDebts[];
  debtTotals: {
    ipva?: number;
    licenciamento?: number;
    multas?: number;
    outros?: number;
  };

  currentPage: number;
  resultsPerPage: number;
  total: number;
  nPages: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

export interface IGetDebtsParams {
  resultsPerPage?: number;
  page?: number;
  orderBy?: string;
  orderByDirection?: string;
  duplicated?: boolean;
  vehiclePlate?: string;
  vehicleUF?: string;
  type?: string;
  installments?: string;
  plate?: string;
  dueDateStart?: string;
  dueDateEnd?: string;
  isExpirationDate?: boolean;
  isPaymentDate?: boolean;
  isUniqueInstallments?: boolean;
  driverName?: string;
  finalNumberPlate?: string;
}

interface IGetDebtsByIdentificatonsBody {
  identification: string;
  consulta?: boolean;
  origin?: string;
}

export const getDebts = async (
  params: IGetDebtsParams,
): Promise<IGetDebtsResult> => {
  const { data } = await api.get(basePath, { params });
  return data;
};

export function useDebtsInfo(params: IGetDebtsParams) {
  params.orderByDirection = params.orderByDirection?.toUpperCase();
  const queryKey = [
    basePath,
    params.duplicated,
    params.orderByDirection,
    params.orderBy,
    params.page,
    params.resultsPerPage,
    params.type,
    params.vehiclePlate,
    params.vehicleUF,
    params.installments,
    params.plate,
    params.dueDateStart,
    params.dueDateEnd,
    params.isExpirationDate,
    params.isPaymentDate,
    params.driverName,
    params.finalNumberPlate,
  ];

  return useQuery(queryKey, () => getDebts(params), {
    staleTime: 60000,
  });
}
